import { importWithRetry } from '@charitystack/shared';

const LOADERS = {
  CROWDFUNDING_FORM: () => import('../CrowdfundingForm'),
  PRODUCT: () => import('../ProductForm'),
  EVENT: () => import('../TicketSelectionForm'),
};
const promises = new Map();
const components = new Map();
let previewLoadsInFlight = 0;

export const isLazyFormType = (type) => Object.prototype.hasOwnProperty.call(LOADERS, type);
export const getLoadedFormType = (type) => components.get(type) || null;
// True from the start of a preview load until it and its in-place retry settle.
// A host's vite:preloadError reload policy (the dashboard's chunkReload.js) reads
// it to leave a preview chunk failure to the local retry and error box.
export const isPreviewFormTypeLoadInFlight = () => previewLoadsInFlight > 0;

function loadPreview(type) {
  previewLoadsInFlight += 1;
  const loading = LOADERS[type]().catch(() => LOADERS[type]());
  const settle = () => { previewLoadsInFlight -= 1; };
  loading.then(settle, settle);
  return loading;
}

export function loadFormType(type, previewMode = false) {
  if (!isLazyFormType(type)) return Promise.resolve(null);
  // Editor previews must never share a donor's reload-capable recovery promise.
  const key = `${previewMode}-${type}`;
  if (!promises.has(key)) {
    const loading = previewMode
      ? loadPreview(type)
      : importWithRetry(LOADERS[type], `FormType-${type}`);
    const component = loading.then((module) => {
      components.set(type, module.default);
      return module.default;
    });
    promises.set(key, component);
    // The editor never reloads, so a failed preview load must not stay cached
    // for the realm: the next mount or type switch imports afresh.
    if (previewMode) {
      component.catch(() => { if (promises.get(key) === component) promises.delete(key); });
    }
  }
  return promises.get(key);
}
